module.exports = __webpack_public_path__ + "img/48.553c406f.jpg";